import type { WorkspaceMark } from "./mark";
export const formatTabTitle = ({
  mark,
  displayName,
  appTitle,
  showNameInTitle = !!mark,
}: {
  mark: WorkspaceMark | null;
  displayName: string;
  appTitle: string;
  showNameInTitle?: boolean;
}): string => {
  const prefix = [mark?.emoji, showNameInTitle && displayName]
    .filter(Boolean)
    .join(" ");
  return prefix ? `${prefix} | ${appTitle}` : appTitle;
};
